// OBD Shield — JS propio. Un solo archivo, vainilla, cargado con defer.
document.addEventListener('DOMContentLoaded', function () {
  initReveal();
  initResenas();
  initGaleriaDrag();
  initGaleriaProducto();
  initVariantesProducto();
  initBarraFija();
});

function initBarraFija() {
  var barra = document.querySelector('[data-obs-barra-fija]');
  var boton = document.querySelector('[data-obs-boton-comprar]');
  if (!barra || !boton) return;
  var botonBarra = barra.querySelector('[data-obs-barra-boton]');
  if (botonBarra) {
    botonBarra.addEventListener('click', function () { boton.click(); });
  }
  if (!('IntersectionObserver' in window)) return;
  var obs = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        barra.classList.toggle('obs-visible', !entry.isIntersecting);
      });
    },
    { threshold: 0 }
  );
  obs.observe(boton);
}

function initGaleriaProducto() {
  var thumbs = document.querySelectorAll('[data-obs-thumb]');
  if (!thumbs.length) return;
  thumbs.forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      var id = thumb.getAttribute('data-obs-thumb');
      document.querySelectorAll('.obs-galeria-principal-item').forEach(function (item) {
        item.classList.toggle('obs-activo', item.getAttribute('data-obs-media-id') === id);
      });
      thumbs.forEach(function (t) { t.classList.toggle('obs-activo', t === thumb); });
    });
  });
}

function initVariantesProducto() {
  var form = document.querySelector('[data-obs-producto-form]');
  if (!form) return;
  var variantesScript = form.querySelector('[data-obs-variantes]');
  if (!variantesScript) return;
  var variantes;
  try { variantes = JSON.parse(variantesScript.textContent); } catch (e) { return; }

  var idInput = form.querySelector('[data-obs-variant-id]');
  var boton = form.querySelector('[data-obs-boton-comprar]');
  var botonTexto = form.querySelector('[data-obs-boton-texto]');
  var precioActual = document.querySelector('[data-obs-precio]');
  var precioComparado = document.querySelector('[data-obs-precio-comparado]');
  var precioBarra = document.querySelector('[data-obs-barra-precio]');
  var grupos = form.querySelectorAll('[data-obs-option-index]');
  if (!grupos.length) return;

  function seleccionActual() {
    var seleccion = [];
    grupos.forEach(function (grupo) {
      var activo = grupo.querySelector('.obs-opcion-valor.obs-activo');
      seleccion.push(activo ? activo.getAttribute('data-obs-option-value') : null);
    });
    return seleccion;
  }

  function encontrarVariante(seleccion) {
    return variantes.find(function (v) {
      return seleccion.every(function (valor, i) { return valor === null || v.options[i] === valor; });
    });
  }

  function formatearDinero(centavos) {
    return (centavos / 100).toLocaleString(document.documentElement.lang || 'es-ES', { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR' });
  }

  function actualizar() {
    var variante = encontrarVariante(seleccionActual());
    if (!variante) return;
    idInput.value = variante.id;
    if (precioActual) precioActual.textContent = formatearDinero(variante.price);
    if (precioBarra) precioBarra.textContent = formatearDinero(variante.price);
    if (precioComparado) {
      if (variante.compare_at_price && variante.compare_at_price > variante.price) {
        precioComparado.textContent = formatearDinero(variante.compare_at_price);
        precioComparado.style.display = '';
      } else {
        precioComparado.style.display = 'none';
      }
    }
    if (boton) {
      boton.disabled = !variante.available;
      if (botonTexto) botonTexto.textContent = variante.available ? botonTexto.dataset.disponible || botonTexto.textContent : (botonTexto.dataset.agotado || botonTexto.textContent);
    }
  }

  grupos.forEach(function (grupo) {
    grupo.querySelectorAll('.obs-opcion-valor').forEach(function (btn) {
      btn.addEventListener('click', function () {
        grupo.querySelectorAll('.obs-opcion-valor').forEach(function (b) { b.classList.remove('obs-activo'); });
        btn.classList.add('obs-activo');
        actualizar();
      });
    });
  });
}

function initReveal() {
  var els = document.querySelectorAll('.obs-reveal');
  if (!els.length) return;
  if (!('IntersectionObserver' in window)) {
    els.forEach(function (el) { el.classList.add('obs-visible'); });
    return;
  }
  var obs = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('obs-visible');
          obs.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.18, rootMargin: '0px 0px -60px 0px' }
  );
  els.forEach(function (el) { obs.observe(el); });
}

function initResenas() {
  var track = document.querySelector('[data-obs-resenas-track]');
  if (!track) return;
  var prev = document.querySelector('[data-obs-resenas-prev]');
  var next = document.querySelector('[data-obs-resenas-next]');
  var card = track.querySelector('.obs-resena');
  if (!card) return;
  function paso() {
    var style = window.getComputedStyle(card);
    var gap = parseFloat(window.getComputedStyle(track).gap || '20');
    return card.getBoundingClientRect().width + gap;
  }
  if (next) next.addEventListener('click', function () { track.scrollBy({ left: paso(), behavior: 'smooth' }); });
  if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -paso(), behavior: 'smooth' }); });
}

function initGaleriaDrag() {
  var track = document.querySelector('[data-obs-galeria-track]');
  if (!track) return;
  var isDown = false, startX, scrollLeft;
  track.addEventListener('mousedown', function (e) {
    isDown = true;
    track.classList.add('obs-dragging');
    startX = e.pageX - track.offsetLeft;
    scrollLeft = track.scrollLeft;
  });
  ['mouseleave', 'mouseup'].forEach(function (ev) {
    track.addEventListener(ev, function () { isDown = false; track.classList.remove('obs-dragging'); });
  });
  track.addEventListener('mousemove', function (e) {
    if (!isDown) return;
    e.preventDefault();
    var x = e.pageX - track.offsetLeft;
    track.scrollLeft = scrollLeft - (x - startX) * 1.4;
  });
}
